import { IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider } from './IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider';
import { sanitizeObject } from '../../../../../utils/sanitization.utils';
import { RuleSetItem } from '../types';

export class IntegrityMonitorPolicyRuleSetsSectionGzDataProvider extends IntegrityMonitorPolicyRuleSetsSectionBaseDataProvider {
  public async getCompanyRuleSetsForPolicy(): Promise<Array<RuleSetItem>> {
    try {
      const companyId = this.dependencies.getPolicyCreatorCompany().companyId;

      const result = await this.dependencies.api.clients.IntegrityMonitorRuleSets.getCompanyRuleSetsForPolicy(
        companyId
      ).toPromise();

      if (!result || !result.success) {
        throw new Error('Invalid response of getCompanyRuleSetsForPolicy');
      }

      return sanitizeObject(result.data);
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  public async getRuleSetsForPolicy(ruleSetIds: Array<string>): Promise<Array<RuleSetItem>> {
    try {
      const result = await this.dependencies.api.clients.IntegrityMonitorRuleSets.getRuleSetsForPolicy(
        ruleSetIds
      ).toPromise();

      if (!result || !result.success) {
        throw new Error('Invalid response of getRuleSetsForPolicy');
      }

      return sanitizeObject(result.data);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
